import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from './Routes';
import { AuthProvider } from './contexts/AuthContextAppwrite';
import { SettingsProvider } from './contexts/SettingsProvider';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SettingsProvider>
          <Routes />
        </SettingsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;